import { TimeHelper } from './../../../utils/time-helper';
import { PlanShared } from './../../general/shared/plan-shared';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-status-fasting-chart',
  templateUrl: './plan-status-fasting-chart.component.html',
  styleUrls: ['./plan-status-fasting-chart.component.scss'],
})
export class PlanStatusFastingChartComponent implements OnInit {
  @Input() type: string;
  @Input() isFasting: boolean;
  @Input() duration?: number;
  @Input() endTime?: number;
  private _dataIsReady = false;
  @Input() set dataIsReady(value: boolean) {
    this._dataIsReady = value;
    if (value) {
      setTimeout(() => {
        this.initial();
      }, 30);
    }
  }

  get dataIsReady(): boolean {
    return this._dataIsReady;
  }

  title = '';
  days = ['۱ شنبه', '۲ شنبه', '۳ شنبه', '۴ شنبه', '۵ شنبه', 'جمعه', 'شنبه'];

  counter: number;

  public doughnutChartLabels: string[] = [];
  public demodoughnutChartData: number[][] = [[0, 0]];
  public doughnutChartType = 'doughnut';
  public chartColors: any[] = [
    {
      backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
      borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
    },
  ];
  public options = {
    responsive: false,
    maintainAspectRatio: false,
    cutoutPercentage: 0,
  };

  constructor(private planShared: PlanShared, private timeHelper: TimeHelper) {}

  ngOnInit() {}

  initial() {
    if (this.type === 'daily') {
      const time = new Date().getHours() * 60 + new Date().getMinutes();
      this.demodoughnutChartData = [[time, 24 * 60 - time]];
      this.title = this.days[new Date().getDay()];
      if (this.isFasting) {
        this.chartColors = [
          {
            backgroundColor: ['#ffbc25', 'rgba(0,0,0,0)'],
            borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
          },
        ];
      } else {
        this.chartColors = [
          {
            backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
            borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
          },
        ];
      }
      setTimeout(() => {
        this.dailyTimer();
      }, 60000);
    } else if (this.type === 'hourly') {
      while (this.endTime < new Date().getTime()) {
        this.endTime += 24 * 60 * 60 * 1000;
      }
      const startTime = this.endTime - this.duration * 60 * 60 * 1000;
      this.counter = new Date().getTime() - startTime;
      this.demodoughnutChartData = [
        [this.counter, this.duration * 60 * 60 * 1000 - this.counter],
      ];
      this.title = this.timeHelper.getTimeStringByMiliseconds(
        this.counter,
        false
      );
      if (this.isFasting) {
        this.chartColors = [
          {
            backgroundColor: ['#ffbc25', 'rgba(0,0,0,0)'],
            borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
          },
        ];
      } else {
        this.chartColors = [
          {
            backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
            borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
          },
        ];
      }
      setTimeout(() => {
        this.hourlyTimer();
      }, 1000);
    }
  }

  dailyTimer() {
    const time = new Date().getHours() * 60 + new Date().getMinutes();
    this.demodoughnutChartData = [[time, 24 * 60 - time]];
    setTimeout(() => {
      this.dailyTimer();
    }, 60000);
  }

  hourlyTimer() {
    this.counter += 1000;
    if (this.counter >= this.duration * 60 * 60 * 1000) {
      this.planShared.refreshDietDay();
    } else {
      this.demodoughnutChartData = [
        [this.counter, this.duration * 60 * 60 * 1000 - this.counter],
      ];
      this.title = this.timeHelper.getTimeStringByMiliseconds(
        this.counter,
        false
      );
      setTimeout(() => {
        this.hourlyTimer();
      }, 1000);
    }
  }
}
